export interface LinkPageLink {
  id: string;
  label: string;
  url: string;
  is_visible: boolean;
}

export interface LinkPage {
  address: string;
  is_active: boolean;
  name: string | null;
  tagline: string | null;
  photo_url: string | null;
  links: LinkPageLink[];
}

export interface PublicLinkPage {
  address: string;
  name: string | null;
  tagline: string | null;
  photo_url: string | null;
  links: { label: string; url: string }[];
}

export type PublicLinkPageResult =
  | { status: 'found'; page: PublicLinkPage }
  | { status: 'unavailable'; profileSlug: string | null };

export type LinkPageHost = {
  address: string;
  siteOrigin: string;
  result: PublicLinkPageResult;
};

export function linkPageDomain(siteOrigin: string): string {
  return new URL(siteOrigin).host.replace(/^www\./, '');
}

export function linkPageUrl(siteOrigin: string, address: string): string {
  const origin = new URL(siteOrigin);
  return `${origin.protocol}//${address}.${linkPageDomain(siteOrigin)}`;
}
